import React, { PropsWithChildren } from 'react'
import { ReactFC } from 'common/types/ReactFC'
import useWindowSize from 'components/util/useWindowSize'
import imageResize, { generateSrcSet } from 'project/image-proxy-web'

const options = [
  {
    description:
      'Get a professional London phone number without needing a physical office.',
    title: 'Start-ups and freelancers.',
  },
  {
    description: `Stay connected wherever your team works.`,
    title: 'Remote and hybrid teams.',
  },
  {
    description: `Expand your business without the cost of extra phone lines.`,
    title: 'Growing SMEs.',
  },
  {
    description: `Build a UK presence while operating from abroad.`,
    title: 'International businesses.',
  },
]

const WhoIsThisFor = () => {
  const size = useWindowSize()
  return (
    <div className='d-flex flex-column align-items-center flex-lg-row gap-lg-8'>
      {!size.isLgOrHigher && (
        // Always fs 36
        <div className='fs-36 fw-semibold fs-fluid-36-80 lh-105 mb-2'>
          A virtual phone number that travels with you
        </div>
      )}
      <div
        style={{
          width: size.isLgOrHigher ? '50%' : '100%',
        }}
      >
        <img
          alt='Never miss a call icon'
          {...generateSrcSet('/images/new/robot-never-miss-call.png', 697, 816)}
          loading='lazy'
          className='img-fluid'
          height={816}
          width={697}
        />
      </div>
      {!size.isLgOrHigher ? (
        <div className='d-flex flex-column gap-2 fw-semibold'>
          <span className='fs-fluid-18-24 lh-119'>
            Give your company a London presence with a 020 London virtual
            telephone number.
          </span>
          {/*fs always 18*/}
          <p className='fs-18 lh-123 '>
            At Hoxton Mix, you can create an established business image with our
            virtual HaiRo™ phone service. Virtual Phone HaiRo™ gives you a
            London virtual phone number that is managed and forwarded by you.
            Wherever you are, whether you're local or travelling
            internationally, you can manage your virtual phone number on the go.
          </p>
        </div>
      ) : (
        <div className='d-flex flex-1 flex-column justify-content-center'>
          <h2 className='fs-fluid-36-80 mb-6 fw-semibold fs-fluid-36-80 lh-105'>
            Who is this for?
          </h2>
          <div className='d-flex flex-column gap-7 lh-114'>
            {options.map((option) => (
              <div className='d-flex flex-column gap-2' key={option.title}>
                {/*fs always 20*/}
                <span className='fs-20 fw-bold'>{option.title}</span>
                <span className='fs-20 fw-semibold color-grey5'>
                  {option.description}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default WhoIsThisFor
